import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { toast } from 'react-toastify';
import { Container } from 'reactstrap';
import ConfirmationPopup from '../../Components/Common/ConfirmationPopup';
import DashboardTable from '../../Components/Common/DashboardTable';
import Loader from '../../Components/Common/Loader';
import NavbarComponent from '../../Components/Header/Navbar';
import { dashboardSchema } from '../../common/data/TableSchema';
import { APIClient } from '../../helpers/ApiHeleps';
import AddMemberStatusModal from './AddMemberStatusModal';
import GenerateAssessmentComp from './GenerateAssessmentComp';
import NeedMappingModal from './NeedMappingModal';
import { getPathAfterDomain, memberStatusObj } from './utils';
import { convertToLowerCase, guid } from '../../Components/Common/Util';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Common/CommonModal';
import { useTranslation } from 'react-i18next';
const Dashboard = () => {
    document.title = 'Assessor | Dashboard';
    const api = new APIClient();
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState('');
    const [dashboardValues, setDashboardValues] = useState([]);
    const [filterDashbordValues, setFilterDashboardValues] = useState([]);
    const [loading, setLoading] = useState(false);
    const [rowData, setRowData] = useState();
    const [needsArr, setNeedsArr] = useState();
    const [memStatus, setMemStatus] = useState();
    const history = useHistory();
    const dispatch = useDispatch();
    const userCredential = useSelector((state) => state.CommonStore.loginToken);
    const [samApiToken, setSamApiToken] = useState();
    const [apiCalling, setApiCalling] = useState(false);

    useEffect(() => {
        if (!userCredential?.token && !userCredential?.apiKey) {
            // channel.postMessage({ action: 'logout' });
            history.replace('/login');
        } else if (userCredential?.token && userCredential?.apiKey) {
            setSamApiToken({ ...userCredential });
        }
    }, []);

    const generateAssesmentLink = async (assesmentData) => {
        try {
            let payLoad = {
                assessmentInternalId: assesmentData?.internalIdentifier,
                placeholderData: {},
                defaultLanguage: 'en',
                memberId: guid()
            };
            let resp = await api.create('initiate', samApiToken, payLoad);
            if (resp?.data?.isSuccess && resp?.status === 200) {
                if (resp?.data?.data) {
                    let url = getPathAfterDomain(resp?.data?.data);
                    setShowModal('');
                    window.open(url, '_blank');
                } else {
                    setShowModal('');
                }
            } else if (!resp?.data?.isSuccess) {
                setShowModal('');
                toast.error('API failed to generate link.');
            }
        } catch (error) {
            toast.error('Something went wrong try again.');
        }
    };

    const prepareFullName = (data) => {
        let firstName = data?.firstName || '';
        let middleName = data?.middleName || '';
        let lastName = data?.lastName || '';
        return `${firstName} ${middleName} ${lastName}`;
    };

    const prepareDashboardData = (dataArr) => {
        let list = dataArr?.map((element) => {
            let fullName = prepareFullName(element?.demographicInfo);
            return {
                firstName: element?.demographicInfo?.firstName || '',
                lastName: element?.demographicInfo?.lastName || '',
                middleName: element?.demographicInfo?.middleName || '',
                phoneNumber: element?.demographicInfo?.phoneNumber || '',
                insuranceNumber: element?.demographicInfo?.insuranceNumber || '',
                hcid: element?.demographicInfo?.hcid || '',
                gender: element?.demographicInfo?.gender || '',
                assessmentEndDate: element?.submitedDate || null,
                assessmentStartDate: element?.assessmentStartDate || null,
                inboundCallDate: element?.initiatedDate || null,
                uniquelink: element?.uniquelink || '',
                link: element?.uniquelink + '/' + element?.memberId,
                status: element?.status,
                memberId: element?.memberId,
                fullName: fullName,
                memberStatus: element?.memberStatus,
                assmtRespId: element?.assessmentResponseId,
                // commercialFlag: element?.demographicInfo?.commercialFlag,
                // nonCommercialFlag: element?.demographicInfo?.nonCommercialFlag
                eligible: element?.isEligible ? 'Yes' : element?.isEligible === false ? 'No' : ''
            };
        });

        return [...list];
    };

    const getDashboardApiCall = async () => {
        try {
            setLoading(true);
            let res = await api.get('responses/all', samApiToken);
            if (res?.data?.isSuccess && res?.data?.data?.length) {
                const preparedValues = prepareDashboardData([...res?.data?.data]);
                setDashboardValues([...preparedValues]);
                setFilterDashboardValues([...preparedValues]);
                setLoading(false);
            } else if (!res?.data?.isSuccess) {
                setDashboardValues([]);
                setLoading(false);
                toast.error('Dash board api failing.');
            }
        } catch (error) {
            setLoading(false);
            toast.error('Something went wrong try again.');
        }
    };

    const approveApiCall = async () => {
        if (!rowData?.uniquelink) {
            toast.error('Link is empty.');
            return;
        }
        let url = rowData?.uniquelink + '/approve';
        try {
            setApiCalling(true);
            let resp = await api.update(url, samApiToken, null);
            if (resp?.data?.isSuccess && resp?.data?.data) {
                toast.success('Member Migrated successfully');
                setApiCalling(false);
                setRowData();
                setShowModal('');
                getDashboardApiCall();
            } else if (!resp?.data?.isSuccess) {
                toast.error(resp?.data?.errorMessage?.[0]);
                setApiCalling(false);
                setRowData();
                setShowModal('');
            }
        } catch (err) {
            toast.error('Something went wrong please try again.');
            setApiCalling(false);
            setRowData();
            setShowModal('');
        }
    };

    useEffect(() => {
        if (samApiToken) getDashboardApiCall();
    }, [samApiToken]);

    const handleActions = (cell, row, index, actionType) => {
        switch (actionType) {
            case 'needs':
                setRowData(row?.original);
                setShowModal(actionType);
                break;
            case 'approve':
                setRowData(row?.original);
                setShowModal(actionType);
                break;
            case 'generateLink':
                setShowModal(actionType);
                break;
            case 'edit':
                setRowData(row?.original);
                if (row?.original?.memberStatus) {
                    setMemStatus({
                        memberStatus: { label: memberStatusObj[row?.original?.memberStatus], value: row?.original?.memberStatus },
                        uniquelink: row?.original?.uniquelink
                    });
                } else {
                    setMemStatus({ memberStatus: '', uniquelink: row?.original?.uniquelink });
                }
                setShowModal(actionType);
                break;
            case 'eligible':
                setShowModal(actionType);
                setRowData(row?.original);
                break;
            default:
                break;
        }
    };

    const navigateToAssessment = (originalRow) => {
        let url = '/' + originalRow?.original?.link;
        window.open(url, '_blank');
    };

    const handleSearch = (input) => {
        let filteredArr = dashboardValues?.filter(
            (item) =>
                item?.fullName?.toLowerCase()?.includes(input?.toLowerCase()) || item?.status?.toLowerCase()?.includes(input?.toLowerCase())
        );
        setFilterDashboardValues([...filteredArr]);
    };

    const CustomActionsTemplate = (cell, row, index) => (
        <>
            {!(convertToLowerCase(row?.original?.status) === 'approved') && (
                <i
                    className="ri-pencil-line align-middle fs-20 cursor-pointer primary-color text-primary me-1"
                    title="Edit Member Status"
                    onClick={() => handleActions(cell, row, index, 'edit')}
                    id={'edit' + index}
                ></i>
            )}

            <i
                className="ri-eye-line align-middle fs-20 cursor-pointer text-primary me-2"
                id={'link' + index}
                title={'AHC screen'}
                onClick={() => navigateToAssessment(row)}
            ></i>

            {convertToLowerCase(row?.original?.status) === 'samsubmitted' && (
                <i
                    className="ri-check-double-line align-middle fs-20 cursor-pointer text-success me-2"
                    title={'Export Member'}
                    onClick={() => {
                        if (row?.original?.eligible === 'Yes') {
                            handleActions(cell, row, index, 'approve');
                        } else if (row?.original?.eligible === 'No') {
                            toast.info('Member is not eligible.');
                        } else {
                            toast.info('Please check member eligibility.');
                        }
                    }}
                    id="approve"
                ></i>
            )}
        </>
    );

    const eligibleCheckAPICall = async (boolValue) => {
        try {
            let url = `${rowData?.uniquelink}/eligible/${boolValue}`;
            const resp = await api.update(url, samApiToken, null);
            if (resp?.data?.isSuccess && resp?.data?.data) {
                setRowData();
                setShowModal('');
                getDashboardApiCall();
            } else if (!resp?.data?.isSuccess && resp?.data?.errorMessage?.length) {
                toast.error(resp?.data?.errorMessage?.[0]);
                setRowData();
                setShowModal('');
            }
        } catch (err) {
            toast.error('Something went wrong please try again.');
            setRowData();
            setShowModal('');
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <NavbarComponent language={undefined} languagesList={undefined} changeLanguages={undefined} showLogout={true} />

                    {loading ? (
                        <Loader />
                    ) : (
                        <DashboardTable
                            cardTitle={'Dashboard'}
                            cardCSS={{ header: 'p-4' }}
                            columns={dashboardSchema}
                            loading={loading}
                            data={filterDashbordValues}
                            customPageSize={10}
                            divClass="table-responsive table-card"
                            tableClass="table table-borderless table-centered align-middle"
                            theadClass="default-table-header text-muted"
                            customActionsTemplate={CustomActionsTemplate}
                            generateButton={'Add Assessment'}
                            handleSearch={handleSearch}
                            handleActionClick={(cell, row, index, actionType) => handleActions(cell, row, index, actionType)}
                        />
                    )}
                </Container>
            </div>

            {showModal === 'approve' && (
                <ConfirmationPopup
                    show={showModal === 'approve'}
                    onCloseClick={() => {
                        setShowModal('');
                    }}
                    disableSave={apiCalling}
                    loading={apiCalling}
                    handleSubmit={approveApiCall}
                    confirmText={<p className="fs-16">Are you sure you want to export this member?</p>}
                    size={'md'}
                />
            )}
            {showModal === 'edit' && (
                <AddMemberStatusModal
                    show={showModal === 'edit'}
                    onCloseClick={() => {
                        setShowModal('');
                        setMemStatus({});
                    }}
                    initialObj={memStatus}
                    refreshDashboard={getDashboardApiCall}
                />
            )}

            {showModal === 'generateLink' && (
                <GenerateAssessmentComp
                    show={showModal === 'generateLink'}
                    onCloseClick={() => setShowModal('')}
                    formSubmit={(data) => generateAssesmentLink(data?.assessment)}
                />
            )}
            {showModal === 'needs' && (
                <NeedMappingModal show={showModal === 'needs'} onCloseClick={() => setShowModal('')} needsData={rowData} />
            )}
            {showModal === 'eligible' && (
                <CommonModal
                    show={showModal === 'eligible'}
                    headerText={t('confirm')}
                    bodyText={<div className="fs-16"> Is this member eligible?</div>}
                    saveText={'Yes'}
                    cancelText={'Cancel'}
                    helpText={'No'}
                    handleSubmit={() => eligibleCheckAPICall(true)}
                    onCloseClick={() => {
                        setRowData();
                        setShowModal('');
                    }}
                    onHelpTextClick={() => eligibleCheckAPICall(false)}
                />
            )}
        </React.Fragment>
    );
};

export default Dashboard;
